import {popupReasonEnum} from './cellcomAbroadVariables';
import lodash from 'lodash';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../utilities/analytics/tracking';
import {otpValidationPopupContent, customerTypeEnum, lobbyTabsEnum, searchParametersEnum, pages} from './cellcomAbroadVariables';

export function gAPopupsLoadingReport({
  popupReason,
  businessOrPrivate,
  errorType,
  startedFromPackage,
  comingFromPackageManager,
  isFamilyProcess,
  isSeparatedSale,
  isBusinessIndividual,
  selectedPackage,
}) {
  switch (popupReason) {
    case popupReasonEnum.ERROR_MESSAGE:
      if (isBusinessIndividual && errorType == 'errorOnFetchPackagesBusinessIndividual') {
        gaEvent(
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT_ON_GENERAL_ERROR.category,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT_ON_GENERAL_ERROR.eventType,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT_ON_GENERAL_ERROR.eventParams,
        );
      }
      break;
    case popupReasonEnum.CONNECTED_COUNTRY_EXISTS:
      if (isBusinessIndividual) {
        gaEvent(
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP.category,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP.eventType,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP.eventParams,
        );
      } else {
        if (businessOrPrivate == customerTypeEnum.PRIVATE) {
          if (startedFromPackage) {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE.eventParams,
            );
          }
        } else {
          if (startedFromPackage) {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGE_SHOW.category,
                gaParams.SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGE_SHOW.eventType,
                gaParams.SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGE_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE.eventParams,
              );
            }
          } else {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_ADDDESTINATION_SHOW.category,
                gaParams.SEPARATED_ADDDESTINATION_SHOW.eventType,
                gaParams.SEPARATED_ADDDESTINATION_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS.eventParams,
              );
            }
          }
        }
      }

      break;
    case popupReasonEnum.LIMIT_COUNTRIES_COUNT_ON_SELECT:
      if (isBusinessIndividual) {
        gaEvent(
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP.category,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP.eventType,
          gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP.eventParams,
        );
      } else {
        if (businessOrPrivate == customerTypeEnum.PRIVATE) {
          if (startedFromPackage) {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE_FROM_PACKAGE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE_FROM_PACKAGE.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_PRIVATE.eventParams,
            );
          }
        } else {
          if (startedFromPackage) {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_FROMPACKAGEMORETHANFIVEDESTINATIONS_SHOW.category,
                gaParams.SEPARATED_FROMPACKAGEMORETHANFIVEDESTINATIONS_SHOW.eventType,
                gaParams.SEPARATED_FROMPACKAGEMORETHANFIVEDESTINATIONS_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS_FROM_PACKAGE.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS_FROM_PACKAGE.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS_FROM_PACKAGE.eventParams,
              );
            }
          } else {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_MORETHAN5_SHOW.category,
                gaParams.SEPARATED_MORETHAN5_SHOW.eventType,
                gaParams.SEPARATED_MORETHAN5_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_LIMITED_COUNTRY_COUNT_POPUP_BUSINESS.eventParams,
              );
            }
          }
        }
      }
      break;
    case popupReasonEnum.ALL_SELECTED_COUNTRIES_ARE_NOT_SUPPORTED_IN_SELECTED_PACKAGE:
      if (businessOrPrivate == customerTypeEnum.PRIVATE) {
        gaEvent(
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTED_SHOW.category,
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTED_SHOW.eventType,
            gaParams.SEPARATED_FROMPACKAGEDESTINATIONNOTSUPPORTED_SHOW.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ALL_COUNTRIES_ARE_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE.eventParams,
          );
        }
      }
      break;
    case popupReasonEnum.SELECTED_COUNTRY_IS_NOT_SUPPORTED_IN_SELECTED_PACKAGE:
      if (businessOrPrivate == customerTypeEnum.PRIVATE) {
        gaEvent(
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGESPECIFICCOUNTRYUNSUPPORTED_SHOW.category,
            gaParams.SEPARATED_FROMPACKAGESPECIFICCOUNTRYUNSUPPORTED_SHOW.eventType,
            gaParams.SEPARATED_FROMPACKAGESPECIFICCOUNTRYUNSUPPORTED_SHOW.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_BUSINESS_FROM_PACKAGE.eventParams,
          );
        }
      }
      break;
    case popupReasonEnum.SELECTED_DATES_ARE_NOT_SUITABLE_FOR_SELECTED_PACKAGE:
      if (businessOrPrivate == customerTypeEnum.PRIVATE) {
        gaEvent(
          gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERTHANPACKAGE_SHOW.category,
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERTHANPACKAGE_SHOW.eventType,
            gaParams.SEPARATED_FROMPACKAGERANGEBIGGERTHANPACKAGE_SHOW.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_BUSINESS_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_BUSINESS_FROM_PACKAGE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_SELECTED_DURATION_MORE_THAN_PACKAGE_DURATION_POPUP_BUSINESS_FROM_PACKAGE.eventParams,
          );
        }
      }
      break;
    case popupReasonEnum.OTP_RESULT:
      if (errorType) {
        gaOTPValidationReport(errorType, businessOrPrivate, startedFromPackage, comingFromPackageManager, isFamilyProcess, selectedPackage);
      }
      break;
    default:
      break;
  }
}

function gaOTPValidationReport(
  errorType,
  businessOrPrivate,
  startedFromPackage,
  comingFromPackageManager,
  isFamilyProcess,
  selectedPackage,
) {
  switch (errorType) {
    case otpValidationPopupContent.isNotCellcomAccount.id:
    case otpValidationPopupContent.otpGeneralError.id:
    case otpValidationPopupContent.abroadIsClosedForAccount.id:
    case otpValidationPopupContent.cantPurchasePackage.id:
      let message = lodash.find(otpValidationPopupContent, function (item) {
        if (item.id == errorType) {
          return item;
        }
      });
      if (businessOrPrivate == customerTypeEnum.PRIVATE) {
        if (startedFromPackage) {
          gtag4({
            event: 'CellcomAbroad_Step6_SubscriberError',
            step: '6',
            action: 'SubscriberError',
            process_type: 'private',
            funnel_name: '3 - Package',
            error: message.gaReportMessageType,
          });
        } else {
          gtag4({
            event: 'CellcomAbroad_Step9_SubscriberError',
            step: '9',
            action: 'SubscriberError',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
            error: message.gaReportMessageType,
          });
        }
      } else {
        if (!startedFromPackage) {
          if (errorType == otpValidationPopupContent.abroadIsClosedForAccount.id) {
            gaEvent(
              gaParams.ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_BUSINESS.category,
              gaParams.ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_BUSINESS.eventType,
              gaParams.ABROAD_LOBBY_OTP_VALIDATION_SOC_ROAM_POPUP_BUSINESS.eventParams,
            );
          } else {
            gtag4({
              event: 'CellcomAbroad_Step3_InactiveSubscriptionMessage',
              step: '3',
              action: 'InactiveSubscriptionMessage',
              process_type: 'business',
              funnel_name: '1 - Lobby - Business',
            });
          }
        }
      }

      if (isFamilyProcess) {
        if (comingFromPackageManager) {
          gaEvent(
            gaParams.ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL.category,
            gaParams.ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL.eventType,
            gaParams.ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL_TICKET_FLOW.category,
            gaParams.ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL_TICKET_FLOW.eventType,
            gaParams.ABROAD_FAMILY_FAILED_GENERAL_ERROR_SCREEN_AFTER_INSTALL_TICKET_FLOW.eventParams,
          );
        }
      }

      break;
    case otpValidationPopupContent.isBusinessAccount.id:
      if (startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step7_BusinessSubscriberMessage',
          step: '7',
          action: 'BusinessSubscriberMessage',
          process_type: 'private',
          funnel_name: '3 - Package',
          content: selectedPackage?.socCode,
        });
      } else {
        gtag4({
          event: 'CellcomAbroad_Step10_BusinessSubscriberMessage',
          step: '10',
          action: 'BusinessSubscriberMessage',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
          content: selectedPackage?.socCode,
        });
      }
      break;
    case otpValidationPopupContent.isCellcomWorkerOtpSale.id:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE_FROM_PACKAGE.eventType,
          gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE_FROM_PACKAGE.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE.category,
          gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE.eventType,
          gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_PRIVATE.eventParams,
        );
      }
      break;
    case otpValidationPopupContent.isCellcomWorkerOtpLobby.id:
      if (!startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_BUSINESS.category,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_IS_CELLCOM_WORKER_BUSINESS.eventParams,
        );
      }
      break;
    case otpValidationPopupContent.isPrivateAccount.id:
      if (!startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step9_NonBusinessSubscriptionMessage',
          step: '9',
          action: 'NonBusinessSubscriptionMessage',
          process_type: 'business',
          funnel_name: '1 - Lobby - Business',
        });
      }
      break;
    case otpValidationPopupContent.defaultPackageExists.id:
      if (businessOrPrivate == customerTypeEnum.PRIVATE) {
        if (startedFromPackage) {
          gtag4({
            event: 'CellcomAbroad_Step12_DefaultPackageMessage',
            step: '12',
            action: 'DefaultPackageMessage',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
            content: selectedPackage?.socCode,
          });
        } else {
          gtag4({
            event: 'CellcomAbroad_Step12_DefaultPackageMessage',
            step: '12',
            action: 'DefaultPackageMessage',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
            content: selectedPackage?.socCode,
          });
        }
      } else {
        if (!startedFromPackage) {
          gtag4({
            event: 'CellcomAbroad_Step6_DefaultRoamingPackageMessage',
            step: '6',
            action: 'DefaultRoamingPackageMessage',
            process_type: 'business',
            funnel_name: '1 - Lobby - Business',
          });
        }
      }
      break;
    case otpValidationPopupContent.autoPackageExists.id:
      if (!startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step5_AutomaticRoamingPackageMessage',
          step: '5',
          action: 'AutomaticRoamingPackageMessage',
          process_type: 'business',
          funnel_name: '1 - Lobby - Business',
        });
        gaEvent(
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUSINESS.category,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_OTP_VALIDATION_AUTO_PACKAGE_POPUP_BUSINESS.eventParams,
        );
      }
      break;
    case otpValidationPopupContent.autoPackageExistsBusinessIndividual.id:
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP.eventParams,
      );

      break;

    case otpValidationPopupContent.rollingPackageExists.id:
      if (!startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step8_IndividualAgreementMessage',
          step: '8',
          action: 'IndividualAgreementMessage',
          process_type: 'business',
          funnel_name: '1 - Lobby - Business',
        });
      }
      break;
    case otpValidationPopupContent.pricePlanVoiceExists.id:
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_VOICE_PACKAGE_EXISTS_POPUP.eventParams,
      );
      break;
    case otpValidationPopupContent.customerGoldClass.id:
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SELECT_ACCOUNT_COMPONENT_GOLD_ACCOUNT_POPUP.eventParams,
      );
      break;
    case otpValidationPopupContent.abroadIsClosedForAccountBusinessIndividual.id:
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP.eventParams,
      );
      break;
  }
}

export function otpValidatedEventGAReport({page, startedFromPackage}) {
  switch (page) {
    case pages.LOBBY:
      if (!startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step1_AfterIdentificationPage',
          step: '1',
          action: 'AfterIdentificationPage',
          process_type: 'business',
          funnel_name: '2 - SearchArea - Business',
        });
      }

      break;
    case pages.SALE:
      if (startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step5_OtpSuccess',
          step: '5',
          action: 'OtpSuccess',
          process_type: 'private',
          funnel_name: '3 - Package',
        });
      } else {
        gtag4({
          event: 'CellcomAbroad_Step8_OtpSuccess',
          step: '8',
          action: 'OtpSuccess',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
        });
      }

      break;
    default:
      break;
  }
}

export function otpValidatedSeparatedSale() {
  gaEvent(
    gaParams.SEPARATED_LOBBYAFTEROTP_SHOW.category,
    gaParams.SEPARATED_LOBBYAFTEROTP_SHOW.eventType,
    gaParams.SEPARATED_LOBBYAFTEROTP_SHOW.eventParams,
  );
}
